import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthQuery } from './auth.query';
import { Logger } from '@core';

const log = new Logger('RoleGuard');

/**
 * Route guard that restricts access based on the logged-in user's role
 * (beusergroup_id). Provide the allowed roles via route data:
 *
 *   data: { roles: [1, 2, 6] }
 *
 * If no roles are configured the guard allows access (acts as a no-op).
 */
@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router, private authQuery: AuthQuery) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const allowedRoles: number[] = (route.data && route.data['roles']) || [];

    if (!allowedRoles.length) {
      return true;
    }

    const role = Number(this.authQuery.role);
    if (allowedRoles.includes(role)) {
      return true;
    }

    log.debug(`Role ${role} not allowed for ${state.url}, redirecting`);
    this.router.navigate(['/error-404'], { replaceUrl: true });
    return false;
  }
}
